import { getArray, get, download, post, put, remove, removeList } from '../index'

export default {
  list: {
    drafts: (params) => getArray('invoices', { ...params,
      type: 'draft',
      role: 'provider'
    }),
    asProviderPending: (params) => {
      return getArray('invoices', { ...params,
        type: 'draft',
        role: 'provider'
      })
    },
    asProviderSend: (params) => {
      return getArray('invoices', { ...params,
        type: 'issued',
        role: 'provider'
      })
    },
    asProviderAccepted: (params) => {
      return getArray('invoices', { ...params,
        type: 'issued',
        role: 'provider'
      })
    },
    asProviderReject: (params) => {
      return getArray('invoices', { ...params,
        type: 'issued',
        role: 'provider'
      })
    },
    asProvider: (params) => {
      return getArray('invoices', { ...params,
        type: 'issued',
        role: 'provider'
      })
    },
    asPayer: (params) => getArray('invoices', { ...params,
      type: 'issued',
      role: 'payer'
    }),
    asPayerPending: (params) => getArray('invoices', { ...params,
      type: 'issued',
      role: 'payer'
    }),
    asPayerProcessed: (params) => getArray('invoices', { ...params,
      type: 'issued',
      role: 'payer'
    }),
    asProviderAndPayer: (params) => getArray('invoices', { ...params,
      type: 'issued',
      role: 'providerandpayer'
    }),
    autoInvoices: (params) => getArray('invoices', { ...params,
      type: 'draft',
      role: 'payer'
    }),
    factoring: (params) => getArray('invoices', { ...params,
      type: 'factoring',
      role: 'provider'
    }),
    thirdPartyDrafts: (params) => getArray('invoices', { ...params,
      type: 'draft',
      role: 'agent'
    }),
    thirdParty: (params) => getArray('invoices', { ...params,
      type: 'issued',
      role: 'agent'
    }),
    thirdPartyAttachable: (params) => get(`invoices`, { ...params,
      type: 'attachable',
      role: 'agent'
    }),
    old: (params) => getArray('invoices', { ...params,
      type: 'issued',
      role: 'provider',
      stored: true
    })
  },
  download: {
    drafts: (params) => download('invoices/download', { ...params,
      type: 'draft',
      role: 'provider'
    }),
    asProviderPending: (params) => download('invoices/download', { ...params,
      type: 'draft',
      role: 'provider'
    }),
    asProviderSend: (params) => download('invoices/download', { ...params,
      type: 'issued',
      role: 'provider'
    }),
    asProviderAccepted: (params) => download('invoices/download', { ...params,
      type: 'issued',
      role: 'provider'
    }),
    asProviderReject: (params) => download('invoices/download', { ...params,
      type: 'issued',
      role: 'provider'
    }),
    asProvider: (params) => download('invoices/download', { ...params,
      type: 'issued',
      role: 'provider'
    }),
    asPayerPending: (params) => download('invoices/download', { ...params,
      type: 'issued',
      role: 'payer'
    }),
    asPayerProcessed: (params) => download('invoices/download', { ...params,
      type: 'issued',
      role: 'payer'
    }),
    asPayer: (params) => download('invoices/download', { ...params,
      type: 'issued',
      role: 'payer'
    }),
    autoInvoices: (params) => download('invoices/download', { ...params,
      type: 'draft',
      role: 'payer'
    }),
    factoring: (params) => download('invoices/download', { ...params,
      type: 'factoring',
      role: 'provider'
    }),
    thirdPartyDrafts: (params) => download('invoices/download', { ...params,
      type: 'draft',
      role: 'agent'
    }),
    thirdParty: (params) => download('invoices/download', { ...params,
      type: 'issued',
      role: 'agent'
    }),
    asProviderAndPayer: (params) => download('invoices/download', { ...params,
      type: 'issued',
      role: 'providerandpayer'
    }),
    old: (params) => download('invoices/download', { ...params,
      type: 'issued',
      role: 'providerandpayer',
      stored: true
    })
  },
  create: {
    drafts: (draft) => post('invoices', draft, {
      type: 'draft',
      role: 'provider'
    }),
    autoInvoices: (autodraft) => post('invoices', autodraft, {
      type: 'draft',
      role: 'payer'
    }),
    thirdPartyDrafts: (invoice) => post('invoices', invoice, {
      type: 'draft',
      role: 'agent'
    })
  },
  update: {
    drafts: (draft, id) => put(`invoices/${id}`, draft, {
      type: 'draft',
      role: 'provider'
    }),
    autoInvoices: (autodraft, id) => put(`invoices/${id}`, autodraft, {
      type: 'draft',
      role: 'payer'
    }),
    thirdPartyDrafts: (invoice, id) => put(`invoices/${id}`, invoice, {
      type: 'draft',
      role: 'agent'
    })
  },
  remove: {
    drafts: (params) => removeList('invoices/{id}', params.id, {
      type: 'draft',
      role: 'provider'
    }),
    autoInvoices: (params) => removeList('invoices/{id}', params.id, {
      type: 'draft',
      role: 'payer'
    }),
    thirdPartyDrafts: (params) => removeList('invoices/{id}', params.id, {
      type: 'draft',
      role: 'agent'
    })
  },
  solicitude: {
    discounts: (body, params) => post('invoices/discounts', body, params),
    factoring: (body, params) => post('invoices/factoring', body, params)
  },
  import: (data) => post('invoices/import', data),
  submit: {
    drafts: (body, params) => put('invoices', body, Object.assign({
      type: 'draft',
      role: 'provider'
    }, params)),
    autoInvoices: (body, params) => put('invoices', body, Object.assign({
      type: 'draft',
      role: 'payer'
    }, params)),
    thirdPartyDrafts: (body, params) => put('invoices', body, Object.assign({
      type: 'draft',
      role: 'agent'
    }, params)),
    asProvider: (body, params) => put('invoices', body, Object.assign({
      type: 'issued',
      role: 'provider'
    }, params)),
    asPayer: (body, params) => put('invoices', body, Object.assign({
      type: 'issued',
      role: 'payer'
    }, params)),
    asPayerPending: (body, params) => put('invoices', body, Object.assign({
      type: 'issued',
      role: 'payer'
    }, params)),
    asPayerProcessed: (body, params) => put('invoices', body, Object.assign({
      type: 'issued',
      role: 'payer',
      newStatus: params.newStatus
    }, params)),
    thirdParty: (body, params) => put('invoices', body, Object.assign({
      type: 'issued',
      role: 'agent'
    }, params))
  },
  get: {
    drafts: (id) => get(`invoices/${id}`, {
      type: 'draft',
      role: 'provider'
    }),
    asProviderPending: (id) => get(`invoices/${id}`, {
      type: 'draft',
      role: 'provider'
    }),
    asProviderSend: (id) => get(`invoices/${id}`, {
      type: 'issued',
      role: 'provider'
    }),
    asProviderAccepted: (id) => get(`invoices/${id}`, {
      type: 'issued',
      role: 'provider'
    }),
    asProviderReject: (id) => get(`invoices/${id}`, {
      type: 'issued',
      role: 'provider'
    }),
    asProvider: (id) => get(`invoices/${id}`, {
      type: 'issued',
      role: 'provider'
    }),
    asPayerPending: (id) => get(`invoices/${id}`, {
      type: 'issued',
      role: 'payer'
    }),
    asPayerProcessed: (id) => get(`invoices/${id}`, {
      type: 'issued',
      role: 'payer'
    }),
    asPayer: (id) => get(`invoices/${id}`, {
      type: 'issued',
      role: 'payer'
    }),
    asProviderAndPayer: (id) => get(`invoices/${id}`, {
      type: 'issued',
      role: 'providerandpayer'
    }),
    autoInvoices: (id) => get(`invoices/${id}`, {
      type: 'draft',
      role: 'payer'
    }),
    factoring: (id) => get(`invoices/${id}`, {
      type: 'factoring',
      role: 'provider'
    }),
    thirdPartyDrafts: (id) => get(`invoices/${id}`, {
      type: 'draft',
      role: 'agent'
    }),
    thirdParty: (id) => get(`invoices/${id}`, {
      type: 'issued',
      role: 'agent'
    }),
    thirdPartyAttachable: (id) => get(`invoices/${id}`, {
      type: 'attachable',
      role: 'agent'
    }),
    old: (id) => get(`invoices/${id}`, {
      type: 'issued',
      role: 'providerandpayer',
      stored: true
    })
  },
  history: (id) => getArray(`invoices/${id}/logs`),
  getAttachments: (id) => getArray(`invoices/${id}/attachments`),
  postAttachments: (id, body) => post(`invoices/${id}/attachments`, body),
  deleteAttachments: (idI, idA) => remove(`invoices/${idI}/attachments/${idA}`),
  getAttachment: (idI, idA) => get(`invoices/${idI}/attachments/${idA}`),
  getFinancing: (idlist) => getArray(`/financing`, {
    id: idlist
  }),
  requestFactoring: data => post(`/financing`, data),
  simulateFinancing: params => get(`/financing/simulation?provider=${params.provider}&amount=${params.amount}`),
  unreject: {
    asPayerProcessed: (body, params) => put('invoices/unreject', body, Object.assign({
      type: 'issued',
      role: 'payer'
    }, params))
  },
  cancelInvoice: {
    asProviderSend: (body, params) => post('invoices/cancel/request', body, Object.assign({
      type: 'issued',
      role: 'provider'
    }, params))
  },
  manageCancelInvoice: {
    asPayerProcessed: (body, params) => post('invoices/cancel/management', body, Object.assign({
      type: 'issued',
      role: 'payer'
    }, params))
  }
  // getSiiInvoices: (siiType) => getArray(`invoices/sii/${siiType}`)
}
